// initialCover.js
'use strict';
export const INITIAL_COVER_ELEMENT_ID = 'initial-cover-element';

export const unmountInitialCover = () => {
  const initialCoverElement = document.getElementById(INITIAL_COVER_ELEMENT_ID);
  if (initialCoverElement) {
    initialCoverElement.remove();
  }
};

// a snippet to unmount initial cover when google bot
export const unmountInitialCoverSnippet = () => /* javascript */ `
  let __isGoogleBot = false;

  try {
    const ua = navigator.userAgent;
    __isGoogleBot = /(Googlebot|AdsBot-Google|FeedFetcher-Google|Google-Read-Aloud|Google-CloudVertexBot|Google-InspectionTool|Google-Site-Verification)/i.test(
      ua
    );
  } catch (error) {
    console.debug('error when check is google bot', error);
  }

  window.__isGoogleBot = __isGoogleBot;

  if (__isGoogleBot) {
    const initialCoverElement = document.getElementById(INITIAL_COVER_ELEMENT_ID);
    if (initialCoverElement) {
      initialCoverElement.remove();
    }
  }
`;
